import {createLogger} from './logging'
import {getUserPermissions, getUserProfile} from 'powtoon-services/current-user/api'
import {UserPermissions, UserProfile} from 'powtoon-services/current-user'
import {ProducerWrapperComponentProps, onGeneratePowtoonCompletedParams} from './types'
import {createZoidComponent} from './createZoidComponent'
import apiConnection from './services/apiConnection'
import {
  calculateProps, generatePowtoonCompleted, validateInputParams, VALIDATION_TYPE, getUserIdOneTimeToken
} from './services/utils'
import {getApiUserIdToken, TokenApiData} from 'powtoon-services/integrations/api-applications/api'
import {getSubdomain} from 'powtoon-commons/utils/urls'
const logger = createLogger('ProducerComponent')
// added comment to test https://powtoon.atlassian.net/browse/VCP-14920

export async function renderProducerComponent(
  url: string,
  containerSelector: string,
  props: ProducerWrapperComponentProps
) {
  
  const container = document.querySelector(containerSelector)
  if (!container) {
    throw new Error(`Container ${containerSelector} not found`)
  }
  
  let userPermissions: UserPermissions | null = null
  let userPermissionsLoading = true

  let userProfileData: { value: UserProfile; status: number } | null = null
  let userProfileLoading = true

  let userIdOneTimeTokenData: TokenApiData | null = null
  let userIdOneTimeTokenLoading = true

  async function fetchDataUserPermissions() {
    try {
      if (userProfileData){
        userPermissionsLoading = true
        userPermissions = await getUserPermissions(apiConnection)()
      }
    } catch (error) {
      logger.log('getUserPermissions unauthenticatedUser or error', error)
    } finally {
      userPermissionsLoading =false
    }
  }

  async function fetchDataUserProfile() {
    try {
      userProfileLoading =true
      userProfileData = await getUserProfile(apiConnection)()
    } catch (error) {
      logger.log('getUserProfile unauthenticatedUser or error', error)
    } finally {
      userProfileLoading =false
    }
  }

  async function fetchDataUserIdOneTimeToken() {
    try {
      
      if (userProfileData){
        userIdOneTimeTokenLoading = true
        userIdOneTimeTokenData = await getApiUserIdToken(apiConnection)()
      }
    } catch (error) {
      logger.log('fetchDataUserIdOneTimeToken error', error)
    } finally {
      userIdOneTimeTokenLoading = false
    }
  }
  async function onGeneratePowtoonCompleted(param: onGeneratePowtoonCompletedParams) {
    if (validateInputParams(
      VALIDATION_TYPE.onGeneratePowtoonCompletedParams,
      'ProducerComponent onGeneratePowtoonCompleted',
      param
    )){
      return await generatePowtoonCompleted(userProfileData, param)
    }
  }

  async function onGetUserIdOneTimeToken() {
    return await getUserIdOneTimeToken()
  }

  function renderComponent() {

    const subDomain = getSubdomain()
    
    const calculatedProps = calculateProps({
      userProfileData,
      userProfileLoading,
      userPermissions,
      userPermissionsLoading,
      userIdOneTimeTokenLoading,
      userIdOneTimeTokenData,
      subDomain,
      renderComponent: container
    })
    if (!calculatedProps.shouldRender ) {
      return null
    }
    
    const component = createZoidComponent(url)

    component({
      ...props,
      ...calculatedProps,
      onGeneratePowtoonCompleted,
      getUserIdOneTimeToken: onGetUserIdOneTimeToken
    }).render(container)
    
  }
  
  await fetchDataUserProfile()
  await fetchDataUserPermissions()
  await fetchDataUserIdOneTimeToken()

  renderComponent()
}